export default function calculateXP () {
    let today = new Date(),
    startDate = new Date('Jan 2018'),
    diff = today.getTime() - startDate.getTime(),
    years = Math.floor(diff / 31556736000);
    return `${years} years`;
}